import { useMutation } from '@tanstack/react-query';
import { GET, GET_VERIFY_NUMBER } from '../../../../services';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { openAlert } from '../../../../components/alert/hooks';

export const useVerifyNumber = ({ setLoading }) =>
  useMutation({
    mutationFn: async ({ warrantyNumberCode }) => {
      const response = await GET(GET_VERIFY_NUMBER(warrantyNumberCode));
      return response.result;
    },
    onSuccess: (result) => {
      const warrantyNumberCode = result?.warranty?.warrantyNumberCode;
      setTimeout(() => {
        setLoading(false);
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_REGISTER_INFO.PATH,
          state: { warrantyNumberCode },
        });
      }, 500);
    },
    onError: (error) => {
      setLoading(false);
      openAlert({ model: 'message', type: 'error', message: error.message });
    },
  });
